import componentRegistry from '../registry.js';
import MagnificPopup from '../../scripts/common/dynamic-imports/MagnificPopup.js';
import Overlay from '../overlay/index.js';
import translation from '../../helpers/translation/translation.js';
import './product-review-report.less';

export default class FeedbackReport {
  #magnificPopup = new MagnificPopup();
  #locked = false;

  constructor({ el }) {
    this.el = el;
    this.link = this.el.querySelector('.js-review-feedbackLink');
    this.el.addEventListener('click', this.#handleClick.bind(this));
  }

  async #handleClick(event) {
    event.preventDefault();

    const loader = new Overlay({ modifier: 'all' });
    loader.show();

    const response = await fetch(this.link.dataset.href);
    const content = await response.text();

    this.#magnificPopup.open({
      items: { src: content },
      type: 'inline',
      fixedContentPos: true,
      mainClass: `mfp--modal ${IS_MOBILE ? ' mfp--mobile' : ''}`,
      callbacks: {
        open: this.#onPopupOpen.bind(this, loader),
      },
    });
  }

  #onPopupOpen(loader) {
    loader.hide();
    const container = document.getElementById('js-feedbackReportPopin');
    const submitButton = document.getElementById('feedbackReportSubmit');
    submitButton.disabled = true;

    // init fields properties
    const fields = [
      {
        id: 'commentaire',
        pattern: null,
      },
      {
        id: 'name',
        pattern: /^[A-zÀ-ÿ](?:[A-z-À-ÿ-\s]*[A-zÀ-ÿ])?$/,
      },
      {
        id: 'email',
        pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      },
    ];

    // generic validate field
    const validateField = (field) => {
      const element = document.getElementById(field.id);
      const isEmpty = element.value.trim() === '';
      const isValid = !isEmpty && (field.pattern ? field.pattern.test(element.value) : true);
      const errorText = isEmpty
        ? translation('comments.controls.commentabuse.field.error2')
        : isValid
        ? ''
        : translation('comments.controls.commentabuse.field.error');
      element.classList.toggle('f-feedbackReport__field--valid', isValid);
      element.classList.toggle('f-feedbackReport__field--invalid', !isValid && !isEmpty);
      document.getElementById(`${field.id}Error`).textContent = errorText;
      return isValid;
    };

    // update submit state
    const updateSubmitButtonState = () => {
      const isFormValid = fields.every(validateField);
      submitButton.disabled = !isFormValid;
    };

    // validate fields on change
    fields.forEach((field) => {
      const element = document.getElementById(field.id);
      element.addEventListener('change', () => {
        validateField(field);
        updateSubmitButtonState();
      });
    });

    const contentContainer = this.#magnificPopup.instance.contentContainer[0];
    contentContainer.addEventListener('submit', (e) => {
      e.preventDefault();
      if (this.#locked) return;

      const form = e.target;
      fetch(form.action, { body: new FormData(form), method: form.method })
        .then((r) => r.text())
        .then((r) => (container.outerHTML = r));
    });
  }
}

componentRegistry.define('js-review-feedbackReport', FeedbackReport);
